import React from 'react'
import EmailField from 'Event/auth/Login/EmailField'
import Page, {
  ErrorMessage,
  StyledPaper,
  StyledFormContainer,
  DescriptionText,
} from 'Event/template/Cards/Login/Page'
import {ForgotPasswordProps} from 'auth/password'
import {useCardsTemplate} from 'Event/template/Cards'
import Description from 'Event/auth/ForgotPassword/Description'
import SubmitButton from 'Event/auth/ForgotPassword/SubmitButton'
import Title from 'Event/template/Cards/ForgotPassword/Title'

export default function ForgotPassword(props: ForgotPasswordProps) {
  return (
    <Page isPreview={false}>
      <StyledPaper>
        <StyledFormContainer>
          <Content {...props} />
        </StyledFormContainer>
      </StyledPaper>
    </Page>
  )
}

export function Content(props: ForgotPasswordProps) {
  const {login} = useCardsTemplate()

  if (props.resetLinkSent) {
    return (
      <Description
        aria-label="password reset link sent"
        Component={DescriptionText}
      >
        {login.passwordReset.successMessage}
      </Description>
    )
  }

  return (
    <>
      <Title />
      <Description
        aria-label="event login description"
        Component={DescriptionText}
      >
        {login.passwordReset?.description}
      </Description>
      <form onSubmit={props.onSubmit}>
        <EmailField {...props} />
        <ErrorMessage>{props.responseError?.message}</ErrorMessage>
        <SubmitButton {...props} />
      </form>
    </>
  )
}
